export const appointmentDropDownStyles = {
  wrapper: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
  },
  title: {
    color: "#000",
    fontFamily: "Roboto Condensed",
    fontSize: "16px",
    fontWeight: 700,
  },
  select: {
    width: "100%",
    fontFamily: "Roboto Condensed",
    fontSize: "18px",
    fontWeight: 400,
    color: "var(--text-primary-000000, #000)",
    "& .MuiSelect-icon": {
      position: "absolute",
      right: 0,
      top: "50%",
      transform: "translateY(-50%)",
      p: 0,
    },
    // Default underline colour (before pseudo element)
    "&:before": {
      borderBottomColor: "#000",
    },
    // Keep underline black when the select is focused / menu open
    "&:after": {
      borderBottomColor: "#000",
    },
    "&.Mui-focused:after": {
      borderBottomColor: "#000",
    },
    // Disabled state customisations
    "&.Mui-disabled": {
      color: "var(--text-primary-000000, #000)",
      WebkitTextFillColor: "var(--text-primary-000000, #000)",
      "& .MuiSelect-icon": {
        color: "#E5E5E5",
      },
      "&:before": {
        borderBottomColor: "#E5E5E5",
      },
      // Ensure inner select element text remains black
      "& .MuiSelect-select.Mui-disabled": {
        color: "var(--text-primary-000000, #000)",
        WebkitTextFillColor: "var(--text-primary-000000, #000)",
      },
    },
  },
  menuProps: {
    PaperProps: {
      sx: {
        borderRadius: 2,
        boxShadow: 3,
        mt: 1,
        fontFamily: "Roboto Condensed",
        fontSize: "18px",
        fontWeight: 400,
        "& .MuiMenuItem-root": {
          fontFamily: "Roboto Condensed",
          fontSize: "18px",
          fontWeight: 400,
        },
      },
    },
    MenuListProps: {
      sx: {
        maxHeight: 300,
        overflowY: "auto",
        fontFamily: "Roboto Condensed",
        fontSize: "18px",
        fontWeight: 400,
        color: "var(--text-primary-000000, #000)",
        py: 1.5,
      },
    },
  },
  menuItem: {
    fontFamily: "Roboto Condensed",
    fontSize: "18px",
    fontWeight: 400,
    color: "var(--text-primary-000000, #000)",
    py: 1.5,
    "&:hover": {
      backgroundColor: "#FFF3E7",
    },
    "&.Mui-focusVisible": {
      backgroundColor: "#FFF3E7",
    },
    "&.Mui-selected": {
      backgroundColor: "#FFF3E7",
      fontWeight: 700,
      "&:hover": {
        backgroundColor: "#FFF3E7",
      },
      "&.Mui-focusVisible": {
        backgroundColor: "#FFF3E7",
      },
    },
  },
};
